const CONTENT_TYPE = 'Content-Type';
const MULTIPART_FORM_DATA = 'multipart/form-data';

export {
  CONTENT_TYPE,
  MULTIPART_FORM_DATA,
};
